import store from '../../store/index.js';

const routeRequirements = {
    "select-gearbox": ['model'],
    "select-fuel": ['model', 'gearboxChoice'],
    "select-trim": ['model', 'gearboxChoice', 'fuelTypeChoice'],
    "select-engine": ['model', 'gearboxChoice', 'fuelTypeChoice', 'trimChoice'],
    "select-paint": ['model', 'gearboxChoice', 'fuelTypeChoice', 'trimChoice', 'engineChoice', 'vehicleId'],
    "select-interior": ['model', 'gearboxChoice', 'fuelTypeChoice', 'trimChoice', 'engineChoice', 'vehicleId', 'paintChoice'],
    "personalise-finance": ['model', 'gearboxChoice', 'fuelTypeChoice', 'trimChoice', 'engineChoice', 'vehicleId', 'paintChoice', 'interiorChoice'],
};

/**
 * Check if the state supports us being on the supplied targetRouteName
 * @param {String} targetRouteName
 * @returns boolean
 */
const routeRequirementsMet = function (targetRouteName) {
    // Get the requirements of the route we're going to and ensure they all match
    const thisRouteRequirements = routeRequirements[targetRouteName];
    for (let index = 0, len = thisRouteRequirements.length; index < len; index++) {
        if (!store.state[thisRouteRequirements[index]]) {
            return false;
        }
    }

    return true;
};

/**
 * Get best matching route based on current state e.g. If the state has the model, gearbox and fuel type choices filled in, but nothing else, then they most likely should be on select-trim
 * @returns String The route name they should be redirected to. e.g. 'select-trim'
 */
const getBestMatchingRouteBasedOnCurrentState = function () {
    // If we didn't meet the requirements then we need to iterate over the routeRequirements and find a stage that is valid and has the most met requirements
    let highestNumberOfRequirementsMet = 0;
    let highestNumberOfRequirementsMetRoute = '';
    Object.keys(routeRequirements).forEach(possibleRouteName => {
        const possibleRouteRequirements = routeRequirements[possibleRouteName];
        // Find the number of requirements that pass for this possible route, or break out early if it fails any
        let numberOfRequirementsMet = 0;
        for (let index = 0, len = possibleRouteRequirements.length; index < len; index++) {
            if (!store.state[possibleRouteRequirements[index]]) {
                return;
            }
            numberOfRequirementsMet++;
        }

        // If this is the best matching route so far, update the best match to this route
        if (numberOfRequirementsMet > highestNumberOfRequirementsMet) {
            highestNumberOfRequirementsMet = numberOfRequirementsMet;
            highestNumberOfRequirementsMetRoute = possibleRouteName;
        }
    });

    if (highestNumberOfRequirementsMetRoute === '') {
        throw Error("No appropriate route found");
    }

    return highestNumberOfRequirementsMetRoute;
};

export {routeRequirementsMet, getBestMatchingRouteBasedOnCurrentState};